import { convertDraft, createDraft as createSystemDraft, getDraftDetail, patchDraft } from "api/services/systemDraft";
import {
  convertDraft as convertLegacyDraft,
  getDraft as getLegacyDraft,
  updateDraft as updateLegacyDraft,
} from "api/services/draftRequest";
import type { RequestFormDraft } from "api/models/draftRequest.model";
import type { CreateSystemDraftResponse, UpdateDraftResponseType } from "api/response";
import type { RequestFormMode } from "@RequestFormV2/context/requestFormMode";

export const loadDraft = (id: string, mode: RequestFormMode = "quote") =>
  mode === "quick" ? getLegacyDraft(id, true) : getDraftDetail(id);

export const saveDraft = (id: string, payload: unknown, mode: RequestFormMode = "quote") =>
  mode === "quick"
    ? updateLegacyDraft(payload as UpdateDraftResponseType, id, true)
    : patchDraft(id, payload as Partial<RequestFormDraft>);

export const convertDraftToRequest = (id: string, mode: RequestFormMode = "quote") =>
  mode === "quick" ? convertLegacyDraft(id, true) : convertDraft(id);

export const validateDraftForReview = (id: string, mode: RequestFormMode = "quote") =>
  mode === "quick"
    ? convertLegacyDraft(id, true, { dry_run: true })
    : convertDraft(id, true);

export const createDraft = (payload: unknown, mode: RequestFormMode = "quote") => {
  if (mode === "quick") {
    return Promise.reject(new Error("Quick request drafts are created from payment-location details"));
  }

  return createSystemDraft(payload as RequestFormDraft).then((res): CreateSystemDraftResponse => res.data);
};
